import { createFileRoute } from "@tanstack/react-router";
import cursosPersonas from "@/assets/cursos-personas.webp.asset.json";
import cert1 from "@/assets/cert-1.png.asset.json";
import cert2 from "@/assets/cert-2.png.asset.json";
import certLsqa from "@/assets/cert-lsqa.png.asset.json";

export const Route = createFileRoute("/cursos/personas/convenio-umayor")({
  head: () => ({
    meta: [
      { title: "Diplomados Certificación U. Mayor | Mine Class" },
      {
        name: "description",
        content:
          "Diplomados y cursos con certificación universitaria, ejecutados en alianza estratégica con la Universidad Mayor.",
      },
      { property: "og:title", content: "Diplomados y Cursos con Certificación Universitaria | Mine Class" },
      { property: "og:description", content: "Diplomados y cursos con certificación de la Universidad Mayor, diseñados para profesionales de la minería." },
      { property: "og:url", content: "https://mine-class.com/cursos/personas/convenio-umayor" },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mine-class.com/cursos/personas/convenio-umayor" }],
  }),
  component: ConvenioContent,
});

function ConvenioContent() {
  return (
    <div className="space-y-8">
      <div className="relative overflow-hidden rounded-2xl aspect-[16/9] bg-[var(--color-brand-purple)]">
        <img
          src={cursosPersonas.url}
          alt="Diplomados y cursos con certificación universitaria"
          className="absolute inset-0 w-full h-full object-cover"
        />
      </div>

      <div>
        <span className="text-[10px] uppercase tracking-widest font-bold text-[var(--color-brand-coral)]">
          Convenio Universidad Mayor
        </span>
        <h2 className="text-2xl md:text-3xl font-bold text-[var(--color-brand-purple)] mt-1">
          Diplomados y Cursos con Certificación Universitaria
        </h2>
        <p className="text-[var(--color-on-surface-variant)] mt-3 text-base md:text-lg leading-relaxed">
          Desarrolla tu carrera en la industria con nuestros diplomados y cursos de especialización
          profesional, ejecutados en alianza estratégica y convenio directo con la Universidad Mayor.
        </p>

        <a
          href="https://umayor.mine-class.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="mt-5 inline-flex items-center gap-2 px-5 py-2.5 bg-[var(--color-brand-coral)] text-white text-xs font-bold uppercase tracking-widest rounded-full hover:bg-[var(--color-brand-purple)] transition-colors"
        >
          Ver Catálogo
          <span className="material-symbols-outlined text-base">arrow_outward</span>
        </a>
      </div>

      <div className="pt-6 border-t border-[var(--color-outline-variant)]">
        <p className="text-[10px] uppercase tracking-widest font-bold text-[var(--color-on-surface-variant)] mb-4">
          Certificaciones
        </p>
        <div className="flex flex-wrap items-center gap-6 md:gap-10 bg-[var(--color-brand-purple)] rounded-xl p-6">
          <img src={cert1.url} alt="Certificación" className="h-10 md:h-12 object-contain" />
          <img src={cert2.url} alt="Certificación" className="h-10 md:h-12 object-contain" />
          <img src={certLsqa.url} alt="LSQA Certificado NCh 2728:2015 Reg. NCh 926" className="h-14 md:h-16 object-contain bg-white rounded p-1" />
        </div>
      </div>
    </div>
  );
}
